"use client";

import Link from "next/link";
import Image from "next/image";
import CTA from "@/components/ui/CTA";
import PageLayout from "@/components/layout/PageLayout";
import { useEffect, useState } from "react";

const typos = [
  "Loooonch",
  "Lunck",
  "Loomch",
  "Lrunchies",
  "Lunchie",
  "Loonch",
  "Lumch",
  "Luncch",
  "Lornch",
  "Lunchiana",
  "Lurnch",
  "Lunxies",
];

export default function NotFound() {
  const [typo, setTypo] = useState(typos[0]);

  useEffect(() => {
    const randomTypo = typos[Math.floor(Math.random() * typos.length)];
    setTypo(randomTypo);
  }, []);

  return (
    <PageLayout>
      <div className="container mx-auto px-4 md:px-6">
        <div className="min-h-[60vh] grid items-center gap-16 py-16 lg:grid-cols-2">
          <div>
            <span className="mb-4 block text-sm uppercase tracking-wider text-text-muted-light dark:text-text-muted-dark">
              404 Error
            </span>
            <h1 className="mb-6 text-4xl font-medium md:text-5xl lg:text-6xl">
              Well, this is awkward
            </h1>
            <div className="space-y-6">
              <p className="text-xl text-text-muted-light dark:text-text-muted-dark md:text-2xl">
                The page you&rsquo;re looking for seems to have wandered off.
                Maybe it&rsquo;s taking a {typo} break, or maybe it never
                existed in the first place.
              </p>
              <div className="flex flex-col gap-4 sm:flex-row">
                <CTA href="/">Back to Homepage</CTA>
                <Link
                  href="/contact"
                  className="inline-flex items-center text-text-light transition-colors hover:underline dark:text-text-dark"
                >
                  Contact Us →
                </Link>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 rounded-xl bg-brand-yellow/10 bg-card-texture" />
            <div className="relative p-8">
              <Image
                src="/assets/graphics/404.webp"
                alt="404 Illustration"
                width={600}
                height={400}
                className="h-auto w-full"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
